import React, { useLayoutEffect, useContext } from "react";
import "./styles/Home.scss";
import Footer from "../../components/Footer/Footer";
import ScriptIcon from "../../components/VectorIcons/ScriptIcon";
import SearchInput from "../../components/SearchInput/SearchInput";
import AppContext from "../../context/appContext";
import UserContext from "../../context/userContext";
import ParameterizedSearchButton from "./ParameterizedSearchButton/ParameterizedSearchButton";
import ParameterizedSearchModal from "./ParameterizedSearchModal/ParameterizedSearchModal";
import { Helmet } from "react-helmet-async";

const Home = () => {
  const appContext = useContext(AppContext);
  const { hasPermission } = useContext(UserContext);

  const toggleParameterizedSearch = (status) => {
    appContext.setCurrentStepBox(status);
  };

  useLayoutEffect(() => {
    appContext.setCurrentSearch("");
    appContext.setFilterSearch("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="Home">
      <Helmet>
        <title>Script</title>
      </Helmet>

      <div className="mainContainer">
        <ScriptIcon width="245" />

        {hasPermission({
          required: [
            "Dramaturgies",
            "Varieties",
            "Researches",
            "LiteraryWorks",
          ],
        }) && <SearchInput />}

        {hasPermission({
          required: [
            "Dramaturgies",
            "Varieties",
            "Researches",
            "LiteraryWorks",
          ],
        }) && (
          <ParameterizedSearchButton
            onClick={() => toggleParameterizedSearch("parameterizedSearch")}
          />
        )}

        {appContext.current.step === "parameterizedSearch" && (
          <ParameterizedSearchModal
            open={appContext.current.step === "parameterizedSearch"}
            clear={() => toggleParameterizedSearch("closed")}
          />
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Home;
